import { useState, useEffect, useCallback } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import CardsSection from './components/CardsSection';
import CarouselSection from './components/CarouselSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import FaqSection from './components/FaqSection';
import AboutSection from './components/AboutSection';
import TopicsSection from './components/TopicsSection';
import Footer from './components/Footer';

const SECTION_IDS = [
  'cards',
  'carousel',
  'features',
  'media',
  'contact',
  'comments',
  'updates',
  'ranking',
  'app',
  'index',
  'faq',
  'about',
  'topics',
];

export default function Home() {
  const [activeSection, setActiveSection] = useState('home');

  const handleScrollSpy = useCallback(() => {
    const scrollY = window.scrollY + 120;
    let current = 'home';

    for (let i = SECTION_IDS.length - 1; i >= 0; i--) {
      const el = document.getElementById(SECTION_IDS[i]);
      if (el && el.offsetTop <= scrollY) {
        current = SECTION_IDS[i];
        break;
      }
    }

    // Map section IDs to nav IDs
    const navMap: Record<string, string> = {
      updates: 'updates',
      index: 'index',
      faq: 'faq',
      comments: 'comments',
    };

    setActiveSection(navMap[current] || 'home');
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScrollSpy, { passive: true });
    return () => window.removeEventListener('scroll', handleScrollSpy);
  }, [handleScrollSpy]);

  const handleNavigate = useCallback((section: string) => {
    setActiveSection(section);
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Header activeSection={activeSection} onNavigate={handleNavigate} />

      <main>
        <Hero />

        {/* 1. #cards - 图文信息卡片 (5项) */}
        <CardsSection />

        {/* 2. #carousel - 焦点专题展示区 (6项) */}
        <CarouselSection />

        {/* 3. #features - 优势特色卡片 (5项) */}
        <FeaturesSection />

        {/* 4. #media - 媒体视频卡片 (3项) */}
        <MediaSection />

        {/* 5. #contact - 联系投稿入口 (1项) */}
        <ContactSection />

        {/* 6. #comments - 读者评论 (4项) */}
        <CommentsSection />

        {/* 7. #updates - 动态快讯列表 (7项) */}
        <UpdatesSection />

        {/* 8. #ranking - 热度榜单 (5项) */}
        <RankingSection />

        {/* 9. #app - 移动端入口 (1项) */}
        <AppSection />

        {/* 10. #index - 主题索引合集 (8项) */}
        <IndexSection />

        {/* 11. #faq - 常见问答 (4项) */}
        <FaqSection />

        {/* 12. #about - 品牌介绍 (1项) */}
        <AboutSection />

        {/* 13. #topics - 话题标签 (11项) */}
        <TopicsSection />
      </main>

      <Footer />
    </div>
  );
}